<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            {{folio?'Editar':'Registrar'}} caja de ahorro {{folio?`Folio:${folio}`:''}}
            <router-link :to="{ name: 'CajaAhorro', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>

            <CajaAhorroForm
              :isLoadingPage="isLoadingPage"
              :trabajadores="trabajadores"
              :trabajadoresAll="trabajadoresAll"
              :fetching="fetching"
              @handledSubmit="(fn) => (handledSubmit = fn)"
              @setData="(fn) => (setData = fn)"
              @onFetch="
                () => {
                  fetching = false;
                }
              "
              @onErrorFetch="
                (err) => {
                  fetching = false;
                  error = err;
                  warningModal = true;
                }
              "
              :pushMedia="pushMedia"
            />

            <div class="mask-edit" v-if="folio&&isLoadingPage">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow flex align-items-center">
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                  <div class="sk-flow-dot bg-load-blue"></div>
                </div>
              </div>
            </div>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'CajaAhorro', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="addCajaAhorroItem()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Caja de Ahorro"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
        size="sm"
        title="Caja de ahorro"
        :centered="true"
        color="success"
        :show.sync="successModal"
        >Guardado con éxito.
        <template #footer>
          <CButton @click="closeModal"  color="success">Aceptar</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import moment from "moment";
import CajaAhorroForm from "../../forms/CajaAhorroForm.vue";

export default {
  name: "NuevoCajaAhorro",

  components: {
    CajaAhorroForm,
  },

  data() {
    return {
      nanoid: undefined,
      folio: this.$route.params.folio,
      date: null,
      fechaInicial: null,
      fechaFinal: null,
      multi: null,
      config: this.$route.params.config,
      monto: null,
      trabajador: null,
      trabajadores: [],
      trabajadoresAll: [],
      // categoria: null,
      categorias: [],
      categoriasAll: [],
      actividad: null,
      actividades: [],
      actividadesAll: [],
      ubicacion: null,
      ubicaciones: [],

      tiempo_extra: false,
      isFijo: false,
      isLoading: false,
      isLoadingPage: false,
      unidad: "kg",
      unidadPagar: "dia",
      currentAlertCounter: 0,
      warningModal: false,
      successModal: false,
      error: "",
      comentarios: '',
      fetching: false,
      medias:[],
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    },
    fechaInicial: {
      required
    },
    fechaFinal: {
      required
    },
    monto: {
      required,
      notNegative: (value) => value >= 0
    }
  },

  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    },
    isValidDateInitial() {
      return !this.$v.fechaInicial.$invalid;
    },
    isValidDateFinal() {
      return !this.$v.fechaFinal.$invalid;
    },
    isValidMonto() {
      return !this.$v.monto.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    this.$store.dispatch('getNanoid');
    this.isLoadingPage = true;

    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "trabajadores",
        filter: {
          where: [
            {
              field: "payload->ubicaciones",
              operator: "regexp",
              value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
            },
            {
              field: "payload->suspendido",
              operator: "=",
              value: false
            },
          ],
        }
      })
    ];

    if(this.folio){
      ubi.push(this.$store.dispatch("customDocumentoHTTP", {
        schema: "caja_de_ahorro",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaizValue]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"] : ["*"]
      }))
    }

    Promise.all(ubi)
      .then(([trabajadores, item]) => {
        this.trabajadores = trabajadores.data.map(trabajador => {
          return { value: trabajador.id, label: trabajador.payload.nombre };
        });
        // this.actividades = actividades.data.map(actividad => {
        //   return { value: actividad.id, label: actividad.payload.nombre };
        // });

        // this.ubicaciones = ubicaciones.data.map(ubicacion => {
        //   return { value: ubicacion.id, label: ubicacion.payload.nombre };
        // });
        // this.categorias = actividades.data.map(actividad => {
        //   return { value: actividad.id, label: actividad.payload.nombre };
        // });

        this.trabajadoresAll = trabajadores.data;
        // this.actividadesAll = actividades.data;


        if(item){

        this.item = item.data[0];
        const form ={
          trabajador:'',
          monto: null,
          fechaInicial: null,
          fechaFinal: null,
          comentarios: '',
          medias:[],
          date: '',
        }
        const trabajador = trabajadores.data.find(f=>f.id===this.item.payload.encabezado.trabajador_id);
        form.trabajador = { value: trabajador.id, label: trabajador.payload.nombre };

        this.nanoid = this.item.payload.encabezado.nanoid;
        form.monto = this.item.payload.encabezado.monto;
        form.fechaInicial = moment(this.item.payload.encabezado.fecha_inicial,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        form.fechaFinal = moment(this.item.payload.encabezado.fecha_final,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        form.comentarios = this.item.payload.encabezado.comentarios;
        form.medias = this.item.payload.anexos;
        form.date = moment(this.item.payload.encabezado.fechahora,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
        this.setData(form)
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    closeModal(){
      this.successModal = false;
      if(this.folio){
        this.$router.push({ name: 'CajaAhorro' });
      }
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    updateCombos() {
      this.isLoadingPage = true;
      this.$store;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaizValue]
              }
            ],
            where: [
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              }
            ]
          }
        })
      ];

      Promise.all(ubi)
        .then(([trabajadores]) => {
          this.trabajadores = trabajadores.data.map(trabajador => {
            return { value: trabajador.id, label: trabajador.payload.nombre };
          });

          this.trabajadoresAll = trabajadores.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },
    async addCajaAhorroItem() {
      this.fetching = true;
      this.isLoading = true;
      await new Promise((res) => {
        const iter = setInterval(() => {
          if (!this.fetching) {
            this.error = "";
            clearInterval(iter);
            res();
          }
        }, 1000);
      });
      this.isLoading = false;

      if (this.error) {
        this.successModal = false;
        return;
      }
      const form = this.handledSubmit();
      console.log(form);
      if (form.skip) {
        return;
      }

      if (form.error && form.warningModal) {

        this.error = form.error;
        this.warningModal = form.warningModal;
        return;
      }
      if (this.folio) {
        form.folio = this.folio;
        form.payload.encabezado.nanoid = this.nanoid;
      }


      this.$store
        .dispatch(
          this.folio
            ? "customDocumentoRemplazarHTTP"
            : "customDocumentoAddHTTP",
          form
        )
        .then(() => {
          this.currentAlertCounter = 6;
        })
        .catch((rej) => {
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })
        .finally(() => {
          this.isLoading = false;
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateCajaAhorro() {
      this.$v.date.$touch();
      this.$v.fechaInicial.$touch();
      this.$v.fechaFinal.$touch();
      this.$v.monto.$touch();
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
